import React, {useCallback, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import {GetCardTypeForBody} from '../../../../../util/utils';
import {labels} from '../../../../../util/utils';
import AresSpecialBodyContainer from './AresSpecialBodyContainer';
import {getCurrentMateriality, getPriorYearMateriality} from '../../../../../selectors/Ares/materiality';
import * as MaterialityAction from '../../../../../actions/Materiality/materialityactions';
import {materialityInputNames, formBodyType, clientSideEventNames} from '../../../../../util/uiconstants';
import NumericInputWithPriorPeriodLabel from '../../NumericInputWithPriorPeriodLabel';
import {useEngagementId} from '../../../../../util/customHooks';

export default function TolerableErrorBody(props) {
	const {
		showGuidance,
		guidanceFilter,
		bodyContent,
		headerId,
		sectionId,
		bodyId,
		updateBodyOptions,
		getBodiesBySectionId,
		isSnapshotView,
		isDisabled
	} = props;

	const formBodyBorder = GetCardTypeForBody(bodyContent);

	const dispatch = useDispatch();

	const currentMateriality = useSelector((store) => getCurrentMateriality(store));
	const priorYearMateriality = useSelector((store) => getPriorYearMateriality(store));
	const priorPeriodTEAmount = priorYearMateriality?.teAmount ? priorYearMateriality.teAmount : undefined;

	const [valueTEAmount, setValueTEAmount] = useState(
		currentMateriality?.teAmount !== 0 ? currentMateriality.teAmount : '0'
	);

	const engagementId = useEngagementId();
	const {tolerableErrorInput} = materialityInputNames;

	const onAccept = useCallback(
		(newValue) => {
			const data = {
				bodyTypeId: formBodyType.TolerableError,
				materialityAmount: newValue === '' ? null : newValue
			};
			return dispatch(MaterialityAction.updateMaterialityById(engagementId, currentMateriality.id, data)).then(() => {
				window.dispatchEvent(new CustomEvent(clientSideEventNames.getValidations));
				setValueTEAmount(newValue);
			});
		},
		[dispatch, currentMateriality.id, engagementId]
	);

	return (
		<Wrapper className={`SectionBodyWrapper TolerableErrorBody ${formBodyBorder}`}>
			<AresSpecialBodyContainer
				showGuidance={showGuidance}
				guidanceFilter={guidanceFilter}
				bodyContent={bodyContent}
				headerId={headerId}
				sectionId={sectionId}
				bodyId={bodyId}
				updateBodyOptions={updateBodyOptions}
				getBodiesBySectionId={getBodiesBySectionId}
				isSnapshotView={isSnapshotView}
			>
				<NumericInputWithPriorPeriodLabel
					priorPeriodLabel={labels.priorperiodte}
					priorPeriodAmount={priorPeriodTEAmount}
					id={tolerableErrorInput}
					name={tolerableErrorInput}
					bodyId={bodyId}
					label={labels.teamount}
					onAccept={onAccept}
					initialValue={valueTEAmount ? valueTEAmount : ''}
					isDisabled={isDisabled}
				/>
			</AresSpecialBodyContainer>
		</Wrapper>
	);
}

const Wrapper = styled.section`
	display: block;
`;
